// src/pages/Cliente/CadastrarEndereco.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CadastrarEndereco.css'; // Importar o arquivo CSS externo.
import Header from '../../components/Form/Header';
import Footer from '../../components/Form/Footer';
import MainContent from '../../components/Form/MainContent';
import Input from '../../components/Input/Input';
import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { formatCurrency } from '../../utils/numberUtils';
import { useTaxasEntregaBairro } from '../../hooks/useTaxasEntregaBairro';



const CadastrarEndereco = () => {
  const { fetchData, postData, putData } = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth(); // Usando o contexto para verificar autenticação
  const { configModulo } = useTheme();
  const usaTaxaEntregaBairro = configModulo?.taxaEntregaBairro === true;
  
  const [id, setId] = useState(0);
  const [logradouro, setLogradouro] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cidadeId, setCidadeId] = useState(1);
  const [cidadesEntrega, setCidadesEntrega] = useState([]);
  const [taxaEntregaBairroId, setTaxaEntregaBairroId] = useState(null);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const {
    taxasEntregaBairro,
    carregandoTaxasBairro,
    erroTaxasBairro,
  } = useTaxasEntregaBairro(cidadeId, usaTaxaEntregaBairro);
  

  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const endereco = await fetchData('/EnderecoApp'); // Faz o request para pegar o usuário
        setId(endereco.id);
        setLogradouro(endereco.logradouro);
        setNumero(endereco.numero);
        setBairro(endereco.bairro);
        setComplemento(endereco.complemento); 
        setCidadeId(endereco.cidadeId || 1);

      } catch (error) {
        console.error('Erro ao obter endereco:', error);
        setErrorMessage('Falha ao carregar os dados do usuário.');
      }
    };

    const fetchCidadesEntrega = async () => {
      try {
        const result = await fetchData('/Cidade/CidadesDelivery');
        setCidadesEntrega(result);
        
      } catch (error) {
        console.log("Erro ao buscar tipos de entrega:" + error);
      }
    };

    // Se o usuário estiver autenticado, busca os dados do usuário
    if (isAuthenticated) {
      fetchUser();
      fetchCidadesEntrega();
    }


    if (location.state && location.state.endereco) {
      const { id, logradouro, numero, bairro, complemento, cidadeId: cidadeEnderecoId } = location.state.endereco; // Assume que o primeiro endereço deve ser editado
      setId(id);
      setLogradouro(logradouro);
      setNumero(numero);
      setBairro(bairro);
      setComplemento(complemento);  
      setCidadeId(cidadeEnderecoId || 1);
    }
  }, [isAuthenticated, location]);

  useEffect(() => {
    if (!usaTaxaEntregaBairro || !bairro || taxasEntregaBairro.length === 0) return;
    const taxa = taxasEntregaBairro.find((item) =>
      Number(item.cidadeId) === Number(cidadeId) &&
      item.descricao?.trim().toLocaleLowerCase('pt-BR') === bairro.trim().toLocaleLowerCase('pt-BR')
    );
    setTaxaEntregaBairroId(taxa?.id || null);
  }, [usaTaxaEntregaBairro, bairro, cidadeId, taxasEntregaBairro]);

  const taxasBairroCidade = taxasEntregaBairro.filter((item) => Number(item.cidadeId) === Number(cidadeId));
  const taxaSelecionada = taxasEntregaBairro.find((item) => item.id === Number(taxaEntregaBairroId));

  const validateForm = () => {
    const newErrors = {};

    if (!logradouro) newErrors.logradouro = true;
    if (!numero) newErrors.numero = true;
    if (!bairro) newErrors.bairro = true;
    if (usaTaxaEntregaBairro && !taxaEntregaBairroId) newErrors.bairro = true;
    setErrors(newErrors);

    // Retorna true se não houver erros
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    const endereco = {
        id: id,
        //cliente: cliente, // Use clienteData em vez do estado
        //cliente: { id: 1 }, //TODO: ajustar para pegar o cliente da sessão
        logradouro,
        numero,
        bairro,
        cidadeId: parseInt(cidadeId),//por enquanto está fixo
        complemento
    };

    try {      

        if (id) {
          const response = await putData('/EnderecoApp', endereco);
          // Se você precisa manipular a resposta de alguma forma, adicione aqui
          console.log("Resposta da API: ", response);
        } else {
          const response = await postData('/EnderecoApp', endereco);   
          // Se você precisa manipular a resposta de alguma forma, adicione aqui
          console.log("Resposta da API: ", response);       
        }
              
        if (taxaEntregaBairroId) localStorage.setItem('taxaEntregaBairroId', taxaEntregaBairroId);
        navigate(-1);
    } catch (error) {
        console.error('Erro: ', error);
    }
  };

  return (
    <>
      <Header titulo="Cadastrar Endereço" />
      <MainContent>
        <div className="formularioContainer">

        <select
            className="input"          
            value={cidadeId}
            onChange={(e) => {
              setCidadeId(e.target.value);
              if (usaTaxaEntregaBairro) {
                setBairro('');
                setTaxaEntregaBairroId(null);
              }
            }}
          >
            {/* <option value="">Todas as Cidades</option> */}
            {cidadesEntrega.map((cidade) => (
              <option key={cidade.id} value={cidade.id}>
                {cidade.nome}
              </option>
            ))}
          </select>

          <Input 
            type="text" 
            value={logradouro} 
            onChange={(e) => setLogradouro(e.target.value)} 
            placeholder="Rua" 
            error={errors.logradouro}
            />  
            
                              
          <Input 
            type="text" 
            value={numero} 
            onChange={(e) => setNumero(e.target.value)} 
            placeholder="Número"  
            error={errors.numero}
          />
          {usaTaxaEntregaBairro ? (
            <>
              <select
                className={`input ${errors.bairro ? 'input-error' : ''}`}
                value={taxaEntregaBairroId || ''}
                disabled={carregandoTaxasBairro || !!erroTaxasBairro}
                onChange={(e) => {
                  const idTaxa = Number(e.target.value) || null;
                  const taxa = taxasEntregaBairro.find((item) => item.id === idTaxa);
                  setTaxaEntregaBairroId(idTaxa);
                  setBairro(taxa?.descricao || '');
                  setErrors((prev) => ({ ...prev, bairro: false }));
                }}
              >
                <option value="">
                  {carregandoTaxasBairro
                    ? 'Carregando bairros...'
                    : taxasBairroCidade.length === 0
                      ? 'Nenhum bairro cadastrado'
                      : 'Selecione o bairro'}
                </option>
                {taxasBairroCidade.map((taxa) => <option key={taxa.id} value={taxa.id}>{taxa.descricao}</option>)}
              </select>
              {erroTaxasBairro && <div className="endereco-bairro-feedback erro">{erroTaxasBairro}</div>}
              {taxaSelecionada && <div className="endereco-taxa-bairro">Taxa de entrega: <strong>{formatCurrency(taxaSelecionada.valor)}</strong></div>}
            </>
          ) : (
            <Input
              type="text"
              value={bairro}
              onChange={(e) => setBairro(e.target.value)}
              placeholder="Bairro"
              error={errors.bairro}
            />
          )}
          <Input 
            type="text" 
            value={complemento} 
            onChange={(e) => setComplemento(e.target.value)} 
            placeholder="Complemento" 
          />
          <button onClick={handleSave} className="button">Salvar Endereço</button>
        </div>
      </MainContent>
      <Footer />
    </>
  );
};

export default CadastrarEndereco;
